import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Button,
  Typography,
  message,
  Spin,
  Breadcrumb,
  Tabs,
  Form,
  Select,
  Modal,
  Input,
} from 'antd';
import _, { update } from 'lodash';
import '../CustomTable/CustomTable.css';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryById } from '../../Actions/CategoryAction';
import { useNavigate, useParams } from 'react-router-dom';
import LinkedAccount from './LinkedAccount';
import StackholderAccount from './StackholderAccount';
import ProductConfiguration from './ProductConfiguration';
import UpdateProductConfiguration from './UpdateProductConfiguration';
import {
  getProductConfiguration,
  updateProductConfiguration,
} from '../../Actions/RazorpaySplittingAction';

const RazorpaySplitting = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState('0');
  const {
    restaurant,
    isCreateLinkedAccountLoading,
    isGetLinkedAccountLoading,
    allLinkedAccountData,
    isAddExistingLinkedAccountIdLoading,
    allProductConfigurationData,
    isUpdateProductionConfigurationtLoading,
  } = useSelector((state) => {
    const { restaurant } = state.restaurant;
    const {
      isCreateLinkedAccountLoading,
      isGetLinkedAccountLoading,
      allLinkedAccountData,
      isAddExistingLinkedAccountIdLoading,
      allProductConfigurationData,
      isUpdateProductionConfigurationtLoading,
    } = state.razorpaySplitting;
    return {
      restaurant,
      isCreateLinkedAccountLoading,
      isGetLinkedAccountLoading,
      allLinkedAccountData,
      isAddExistingLinkedAccountIdLoading,
      allProductConfigurationData,
      isUpdateProductionConfigurationtLoading,
    };
  });
  const requirements = (allProductConfigurationData?.requirements || []).map(
    (req) => {
      const parts = req.field_reference.split('.');
      return {
        name: parts[parts.length - 1],
        description: req.description,
      };
    }
  );

  useEffect(() => {
    dispatch(getProductConfiguration());
  }, []);

  // useEffect(() => { })
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [hasShownModal, setHasShownModal] = useState(false);
  const [completedSteps, setCompletedSteps] = useState([
    false,
    false,
    false,
    false,
  ]);

  useEffect(() => {
    if (!hasShownModal && requirements.length > 0) {
      setIsModalVisible(true);
      setHasShownModal(true);
    }
  }, [requirements, hasShownModal]);

  const markStepComplete = (stepIndex) => {
    setCompletedSteps((prev) => {
      const updated = [...prev];
      updated[stepIndex] = true;
      return updated;
    });
  };

  const onTabClick = (key) => {
    setActiveKey(key);
    // const current = Number(activeKey);
    // const clicked = Number(key);

    // if (clicked <= current || completedSteps[clicked - 1]) {
    //   setActiveKey(key);
    // } else {
    //   message.error('Please complete the previous step first');
    // }
  };
  const next = () => {
    const currentIndex = Number(activeKey);
    markStepComplete(currentIndex);
    setActiveKey(String(currentIndex + 1));
  };

  const prev = () => {
    setActiveKey((prev) => String(Number(prev) - 1));
  };

  const onFinish = (values) => {
    const formattedValues = {
      product_configuration: {
        settlements: {
          account_number: values.account_number,
          ifsc_code: values.ifsc_code,
          beneficiary_name: values.beneficiary_name,
        },
      },
    };

    dispatch(
      updateProductConfiguration(
        formattedValues,
        successCallback,
        failureCallback
      )
    );
  };

  const successCallback = (response) => {
    setIsModalVisible(false);
    message.success('Product configuration data is submitted successfully');
  };

  const failureCallback = (error) => {
    const errorMessage =
      error?.error?.error?.description ||
      error?.error?.description ||
      error?.error ||
      'Something went wrong.';

    setTimeout(() => {
      message.error(errorMessage);
    }, 1000);
  };

  const steps = [
    {
      title: 'Step 1',
      content: (
        <LinkedAccount
          next={next}
          markStepComplete={() => markStepComplete(0)}
        />
      ),
    },
    {
      title: 'Step 2',
      content: (
        <StackholderAccount
          next={next}
          prev={prev}
          activeKey={activeKey}
          markStepComplete={() => markStepComplete(1)}
        />
      ),
    },
    {
      title: 'Step 3',
      content: (
        <ProductConfiguration
          next={next}
          prev={prev}
          activeKey={activeKey}
          markStepComplete={() => markStepComplete(2)}
        />
      ),
    },
    {
      title: 'Step 4',
      content: <UpdateProductConfiguration prev={prev} activeKey={activeKey} />,
    },
  ];

  const { orgId } = useParams();

  const handleCloseRestaurant = () => {
    navigate('/restaurants');
    dispatch(getCategoryById(''));
    dispatch({
      type: 'GET_SELECTED_RESTAURANT_ID',
      payload: '',
    });
    dispatch({
      type: 'GET_LINKED_ACCOUNT_SUCCESS',
      payload: '',
    });
    dispatch({
      type: 'GET_STACKHOLDER_ACCOUNT_SUCCESS',
      payload: '',
    });
    dispatch({
      type: 'GET_PRODUCT_CONFIGURATION_SUCCESS',
      payload: '',
    });
  };
  const handleCloseRestaurantDrawer = () => {
    navigate(`/restaurants/${orgId}`);
    dispatch({
      type: 'GET_LINKED_ACCOUNT_SUCCESS',
      payload: '',
    });
    dispatch({
      type: 'GET_STACKHOLDER_ACCOUNT_SUCCESS',
      payload: '',
    });
    dispatch({
      type: 'GET_PRODUCT_CONFIGURATION_SUCCESS',
      payload: '',
    });
  };

  return (
    <Spin spinning={false}>
      <Row gutter={[24, 24]}>
        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
          <Row gutter={[24, 24]}>
            <Col xl={23} lg={23} md={23} sm={23} xs={23}>
              <Breadcrumb separator='>'>
                <Breadcrumb.Item
                  onClick={() => handleCloseRestaurant()}
                  className='breadcrumRestaurant'
                >
                  Restaurants
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  onClick={() => handleCloseRestaurantDrawer()}
                  className='breadcrumRestaurant'
                >
                  {restaurant?.name}
                </Breadcrumb.Item>
                <Breadcrumb.Item className='breadcrumUsers'>
                  Razorpay splitting
                </Breadcrumb.Item>
              </Breadcrumb>
            </Col>
            <Col span={12}>
              <Typography className='heading'>Razorpay splitting</Typography>
            </Col>
            {allProductConfigurationData?.id && (
              <Col span={12}>
                <Row justify='end'>
                  <Col span={24}>
                    <Typography className='heading'>
                      Account status:{' '}
                      {allProductConfigurationData?.activation_status}
                    </Typography>
                  </Col>
                </Row>
              </Col>
            )}
            <Col span={24}>
              <Row>
                <Col span={14}>
                  <Tabs
                    activeKey={activeKey}
                    onTabClick={onTabClick}
                    tabBarStyle={{ borderBottom: '2px solid #eee' }}
                  >
                    {steps.map((step, index) => (
                      <Tabs.TabPane
                        key={index.toString()}
                        tab={
                          <span
                            className={`tabSteps ${
                              activeKey === index.toString() ? 'activeTab' : ''
                            }`}
                          >
                            {step.title}
                          </span>
                        }
                      >
                        {step.content}
                        {/* {index < steps.length - 1 && (
                            <div style={{ marginTop: 24 }}>
                              <Button className='detailsButton' size='large' onClick={next}>
                                Next
                              </Button>
                            </div>
                          )}
                          {index === steps.length - 1 && (
                            <div style={{ marginTop: 24 }}>
                              <Button type='primary'>Submit</Button>
                            </div>
                          )} */}
                      </Tabs.TabPane>
                    ))}
                  </Tabs>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      {activeKey === '0' &&
        allProductConfigurationData?.requirements?.some(
          (req) => req.description
        ) && (
          <Modal
            // title='Bank Account Verification Required'
            open={isModalVisible}
            footer={null}
            closable={true}
            onCancel={() => setIsModalVisible(false)}
          >
            {allProductConfigurationData.requirements.every((req) =>
              req.description?.toLowerCase().includes('max retry exceeded')
            ) ? (
              <div className='contactSupport'>
                <Typography className='errorMessage'>
                  We are unable to verify your bank account.
                </Typography>
                <Typography style={{ marginTop: '10px' }} className='tabSteps'>
                  Please{' '}
                  <a
                    href='https://razorpay.com/support'
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    contact Razorpay Support
                  </a>{' '}
                  for assistance.
                </Typography>
              </div>
            ) : (
              <>
                <Typography className='errorMessage'>
                  Please solve these issues:
                </Typography>
                <Spin spinning={isUpdateProductionConfigurationtLoading}>
                  <Form form={form} onFinish={onFinish} layout='vertical'>
                    {requirements.map(({ name, description }) => (
                      <Form.Item
                        key={name}
                        label={
                          <span
                            style={{
                              fontFamily: 'Circular-900',
                              fontSize: '14px',
                              wordSpacing: '-3px',
                            }}
                          >
                            {name.replace(/_/g, ' ').toUpperCase()}
                          </span>
                        }
                        name={name}
                        rules={[
                          {
                            required: true,
                            message: `${name.replace(/_/g, ' ')} is required.`,
                          },
                        ]}
                        help={
                          <Typography
                            className='errorMessage'
                            style={{ textAlign: 'left' }}
                          >
                            {description}
                          </Typography>
                        }
                      >
                        <Input
                          placeholder={`Enter ${name.replace(/_/g, ' ')}`}
                        />
                      </Form.Item>
                    ))}

                    <Form.Item>
                      <Button htmlType='submit' className='detailsButton'>
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </Spin>
              </>
            )}
          </Modal>
        )}
    </Spin>
  );
};

export default RazorpaySplitting;
